/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ userId: ZodTypes.Id });

export const AdminSuperUserPatch = {
  id: 'admin-user-superuser-.patch',
  tag: 'Admin',
  summary: 'Update superuser',
  description: 'Update superuser',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/administration/user/${params.userId}/superuser`,
  request: {
    query: z.strictObject({
      isSuperuser: z
        .string()
        .refine(value => value === 'true' || value === 'false', {
          message: 'Value must be a boolean',
        })
        .transform(value => value === 'true'),
    }),
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
